<!-- src/components/ConfirmDialog.vue -->
<template>
  <v-dialog v-model="dialogOpen" persistent max-width="400">
    <v-card>
      <v-card-title>{{title}}</v-card-title>
      <v-card-text>{{ message }}</v-card-text>
      <v-card-actions>
        <v-btn type="button" class="btn-outline" @click="cancel">Annulla</v-btn>
        <v-btn type="button" class="btn-primary" @click="confirm">Conferma</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script setup>
import { useConfirmDialogStore } from '@/store/confirmDialogStore.ts';
import { computed } from 'vue';


const store = useConfirmDialogStore();

const dialogOpen = computed({
  get: () => store.isOpen,
  set: (value) => {
    if (!value) store.close();
  },
});

const message = computed(() => store.message);
const title = computed(() => store.title);
const cancel = () => store.cancel();
const confirm = () => store.confirm();
</script>